import React, { forwardRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons/faTriangleExclamation'

export const FunctionalityViolationMark = forwardRef<any>(function FunctionalityViolationMark(props, ref) {
	return (
		<span {...props} ref={ref}>
            <FontAwesomeIcon
	            icon={faTriangleExclamation}
	            color="#4F4F4F"
            />
			&nbsp;
        </span>
	)
})